<template>
    <transition
        enter-from-class="transform -translate-x-96"
        leave-from-class="transform translate-x-0"
        leave-to-class="transform -translate-x-96"
        enter-to-class="transform translate-x-0"
        enter-active-class="transition duration-500"
        leave-active-class="transition duration-500"
    >
        <slot />
    </transition>
</template>
